import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import type { Id } from "@convex/_generated/dataModel";
import { useLeague } from "@/features/leagues/hooks/useLeague";
import { ScoringRulesView } from "@/features/leagues/scoring/components/ScoringRulesView";
import { PageContainer } from "@/shared/layout/PageContainer";
import { PageHeader } from "@/shared/layout/PageHeader";
import { Skeleton } from "@/shared/ui/Skeleton";
import { useT } from "@/shared/i18n/LocaleContext";

export const Route = createFileRoute("/_authenticated/leagues/$leagueId/scoring")({
  component: LeagueScoringPage,
});

function LeagueScoringPage() {
  const { leagueId } = Route.useParams();
  const t = useT();
  const data = useLeague(leagueId as Id<"leagues">);
  const rules = useQuery(api.scoringRules.getLiveRules);

  if (data === undefined || rules === undefined) {
    return (
      <PageContainer>
        <Skeleton className="h-12 w-2/3 mb-8" />
        <Skeleton className="h-64 w-full mb-6" />
        <Skeleton className="h-64 w-full" />
      </PageContainer>
    );
  }

  const { league } = data;

  return (
    <PageContainer>
      <PageHeader
        eyebrow={league.name}
        title={t("league.scoring.title")}
        subtitle={t("league.scoring.subtitle")}
      />
      <ScoringRulesView rules={rules} />
    </PageContainer>
  );
}
